import React, { forwardRef } from "react";
import { Autocomplete, Box, Paper, TextField } from "@mui/material";
import { theme } from "../../views/App";

// Autocomplete component function
const AutoCompleteComponent = forwardRef(
  (
    {
      renderOption,
      getOptionLabel,
      list,
      getOptionDisabled,
      name,
      textFieldProps,
      handleChange,
      error,
      clear,
      size,
      width,
      disabled,
      helperText,
      value,
      disableClearable,
      multiple,
      filterOptions,
      defaultValue,
      isOptionEqualToValue,
      limitTags,
      renderTags,
    },
    ref
  ) => {
    return (
      //Added the box width
      <Box sx={{ width: !width ? 200 : width }}>
        <Autocomplete
          // multiple={true}
          disablePortal
          defaultValue={defaultValue}
          getOptionLabel={getOptionLabel}
          value={value}
          tag
          limitTags={limitTags ? limitTags : 10}
          disableClearable={disableClearable}
          isOptionEqualToValue={isOptionEqualToValue}
          multiple={multiple}
          disabled={disabled}
          clearOnBlur={true}
          ref={ref}
          id="combo-box-demo"
          options={list}
          getOptionDisabled={getOptionDisabled}
          renderOption={renderOption}
          filterOptions={filterOptions}
          //paper component for styling dropdown list
          PaperComponent={({ children }) => (
            <Paper
              style={{
                border: `1px solid ${theme.palette.primary.main}`,
                borderRadius: theme.palette.buttonComponent.borderRadius.small,
                marginTop: 2,
              }}
            >
              {children}
            </Paper>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              {...textFieldProps}
              helperText={helperText}
              size={size}
              error={error}
              name={name}
              sx={{
                // '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                //   border : `1.5px solid ${theme.palette.primary.main}`,
                // },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
            />
          )}
          slotProps={{
            //zIndex less than the Appbar
            popper: {
              sx: {
                zIndex: 1000,
              },
            },
          }}
          onChange={handleChange}
          renderTags={renderTags}
        />
      </Box>
    );
  }
);

export default AutoCompleteComponent;
